
import { Column } from "primereact/column";
import useUrlState from "@ahooksjs/use-url-state";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaDataTable from "../../../../components/MeaDataTable";
import MeaStudentStatus2 from "../../../../components/MeaStudentStatus2";
import GenerateAttendancesModal from "./GenerateAttendancesModal";
import UpdateAttendanceMessageModal from "./UpdateAttendanceMessageModal";
import attendancesAPI from "../../../../services/attendances";
import MeaButton from "../../../../components/MeaButton";
import { PERMISSION_TRAINING_ATTANDANCES } from "../../../../permissions";
import MeaAttendancesProgressBar2 from "../../components/MeaAttendancesProgressBar2";
import { useMediaQuery } from "react-responsive";
import { Menu } from "primereact/menu";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import MeaStudentAvatar from "../../components/MeaStudentAvatar";

const AttendancesListComponent = forwardRef((props, ref) => {
  const { schoolId, trainingId, session, showToolbar, showFilterButton, showAddButton } =
    props;
  const { hasPermission } = useAuthContext();
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();

  const accessToken = "";
  //
  const isMobile = useMediaQuery({
    query: '(max-width: 575px)'
  })
  //
  const hasUpdatePermission = hasPermission(PERMISSION_TRAINING_ATTANDANCES.UPDATE)
  //
  const createModalRef = useRef();
  const updateModalRef = useRef();
  const actionsMenuRef = useRef();
  //

  const [state, setState] = useUrlState({
    attendancesPage: "1",
    attendancesPageSize: "30",
    attendancesFilter: JSON.stringify({
      course_session_id: session?.id || "",
    }),
  });
  //
  const queryList = attendancesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize,
    JSON.parse(state.attendancesFilter)
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //
  const [attendance, setAttendance] = useState(null);
  const attendanceActions = [
    {
      label: "Re-générer la feuille de présence",
      icon: "pi pi-refresh",
      command: () => {
        if (createModalRef.current) {
          createModalRef.current.show(() => {
            queryList.refetch();
          });
        }
      },
    },
  ];
  //
  const startToolbarTemplate = (
    <div>
      {showAddButton && queryList?.data?.meta?.total <= 0 && (
        <MeaButton
          label="Générer la feuille de présence"
          icon="pi pi-plus"
          className="p-button mr-2 action"
          onClick={() => {
            createModalRef.current.show(() => {
              queryList.refetch();
            });
          }}
          data-pr-tooltip="Générer la feuille de présence"
          permission={PERMISSION_TRAINING_ATTANDANCES.CREATE}
        />
      )}
    </div>
  );
  //
  const rowClass = (data) => {
    return {
      'bg-green-50': isMobile && (data?.status === "PRESENT"),
      'bg-red-50': isMobile && (data?.status === "ABSENT"),
      'bg-orange-50': isMobile && (data?.status === "LATE"),
    };
  };
  //
  return (
    <>
      <GenerateAttendancesModal schoolId={schoolId} trainingId={trainingId} ref={createModalRef} session={session} />
      {queryList?.data?.meta?.total > 0 &&
        <div className="flex justify-content-between bg-white ">
          <MeaAttendancesProgressBar2
            attendances={queryList?.data?.data}
            showValues={true}
            showLegends={true}
          />
          <div>
            <Menu
              ref={actionsMenuRef}
              model={attendanceActions}
              popup
              id="popup_actions_prensence_menu"
            />
            <MeaButton
              text
              icon="pi pi-cog"
              onClick={(event) => actionsMenuRef.current?.toggle(event)}
              permission={PERMISSION_TRAINING_ATTANDANCES.CREATE}
            />
          </div>
        </div>
      }
      <MeaDataTable
        query={queryList}
        serviceAPI={attendancesAPI}
        names={{
          pagination: "attendances",
          singular: "présence",
          plural: "présences",
        }}
        startToolbarTemplate={startToolbarTemplate}
        showFilterButton={showFilterButton}
        rowClassName={rowClass}
        showDeleteButton={hasPermission(PERMISSION_TRAINING_ATTANDANCES.DELETE)}
        showToolbar={showToolbar}
        setPage={setPage}
        setPageSize={setPageSize}
        paginatorPosition="bottom"
        schoolId={schoolId}
        trainingId={trainingId}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
        <Column
          header="Elève"
          headerStyle={{ width: '19rem' }}
          body={(item) => {
            return (
              <div className="flex flex-column align-items-start">
                <div>
                  <MeaStudentAvatar schoolId={schoolId} trainingId={trainingId} student={item?.student} />
                  {item?.student?.status !== "ENROLLED" && <span className="in-line pl-5 text-500"><MeaStudentStatus2 student={item?.student} /></span>}
                </div>
                <div className="sm:hidden in-line pt-2">
                  <div className="flex align-items-center pl-5">
                    <MeaButton label="Présent" size="small" severity="success" disabled={!hasUpdatePermission} text={item?.status !== "PRESENT"} className="mr-2" onClick={(e) => {
                      attendancesAPI
                        .UpdateOne(schoolId, trainingId, accessToken, item?.id, { status: "PRESENT" })
                        .then((data) => {
                          queryList.refetch();
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    }} />
                    <MeaButton label="Retard" size="small" severity="warning" disabled={!hasUpdatePermission} text={item?.status !== "LATE"} className="mr-2" onClick={(e) => {
                      attendancesAPI
                        .UpdateOne(schoolId, trainingId, accessToken, item?.id, { status: "LATE" })
                        .then((data) => {
                          queryList.refetch();
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    }} />
                    <MeaButton label="Absent" size="small" severity="danger" disabled={!hasUpdatePermission} text={item?.status !== "ABSENT"} className="mr-2" onClick={(e) => {
                      attendancesAPI
                        .UpdateOne(schoolId, trainingId, accessToken, item?.id, { status: "ABSENT" })
                        .then((data) => {
                          queryList.refetch();
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    }} />
                    <MeaButton
                      icon="pi pi-file-edit"
                      rounded
                      text
                      aria-label="Filter"
                      onClick={() => {
                        setAttendance(item);
                        if (updateModalRef.current) {
                          updateModalRef.current.show(() => {
                            queryList.refetch();
                          });
                        }
                      }}
                      permission={PERMISSION_TRAINING_ATTANDANCES.UPDATE}
                    />
                  </div>
                </div>
                <div className="sm:hidden in-line text-sm text-500 pt-2 pb-2 pl-5">{item.message}</div>
              </div>
            )
          }}
        ></Column>
        {!isMobile && <Column header="Présence" field="status"
          body={(item) => (
            <>
              <div className="flex align-items-center">
                <div style={{ minWidth: '19rem' }}>
                  <MeaButton label="Présent" severity="success" disabled={!hasUpdatePermission} outlined={item?.status !== "PRESENT"} className="mr-2" onClick={(e) => {
                    attendancesAPI
                      .UpdateOne(schoolId, trainingId, accessToken, item?.id, { status: "PRESENT" })
                      .then((data) => {
                        queryList.refetch();
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }} />
                  <MeaButton label="Retard" severity="warning" disabled={!hasUpdatePermission} outlined={item?.status !== "LATE"} className="mr-2" onClick={(e) => {
                    attendancesAPI
                      .UpdateOne(schoolId, trainingId, accessToken, item?.id, { status: "LATE" })
                      .then((data) => {
                        queryList.refetch();
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }} />
                  <MeaButton label="Absent" severity="danger" disabled={!hasUpdatePermission} outlined={item?.status !== "ABSENT"} className="mr-2" onClick={(e) => {
                    attendancesAPI
                      .UpdateOne(schoolId, trainingId, accessToken, item?.id, { status: "ABSENT" })
                      .then((data) => {
                        queryList.refetch();
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }} />
                  <MeaButton
                    icon="pi pi-file-edit"
                    rounded
                    text
                    aria-label="Filter"
                    onClick={() => {
                      setAttendance(item);
                      if (updateModalRef.current) {
                        updateModalRef.current.show(() => {
                          queryList.refetch();
                        });
                      }
                    }}
                    permission={PERMISSION_TRAINING_ATTANDANCES.UPDATE}
                  />
                </div>
                <span>{item.message}</span>
              </div>
            </>
          )} />}


      </MeaDataTable>

      <UpdateAttendanceMessageModal ref={updateModalRef} attendance={attendance} />
    </>
  );
});

export default AttendancesListComponent;
